import { Component, OnInit, OnDestroy } from '@angular/core';

import { forkJoin } from 'rxjs';

import { AlertService } from '../../services/alert.service';
import { FirmwareService } from '../../services/firmware.service';
import { ProgressIndicatorService } from '../../services/progress-indicator.service';

@Component({
    selector: 'firmware',
    templateUrl: './firmware.component.html',
    styleUrls: ['./firmware.component.scss']
})
export class FirmwareComponent implements OnInit, OnDestroy {

    products: any[] = [];

    selectedProduct: any;

    selectedApi!: string | null;

    constructor(
        private alertService: AlertService,
        private progressIndicatorService: ProgressIndicatorService,
        private firmwareService: FirmwareService
    ) {
    }

    ngOnInit() {
        this.refreshFirmwares();
    }

    ngOnDestroy() {
    }

    refreshFirmwares() {
        if (this.selectedProduct == null || this.selectedApi == null) {
            this.selectedProduct = null;
            this.selectedApi = null;
        }
        this.getProducts();
    }

    getProducts() {
        this.progressIndicatorService.progress = true;
        forkJoin([
            this.firmwareService.getProductsV2(),
            this.firmwareService.getProducts()
        ]).subscribe({
            next: ([productsV2, productsV1]) => {
                console.log('FirmwareComponent.getProducts.firmwareService.getProductsV2.value', productsV2);
                console.log('FirmwareComponent.getProducts.firmwareService.getProducts.value', productsV1);
                this.progressIndicatorService.progress = false;

                let products = [];
                for (let product of productsV2.products) {
                    let p: any = products.find(p => p.name == product);
                    if (p === undefined) {
                        p = { id: null, name: product, api: [] };
                        products.push(p);
                    }
                    p.api.push('v2');
                }

                for (let product of productsV1) {
                    let p: any = products.find(p => p.name == product.name);
                    if (p === undefined) {
                        p = { id: null, name: product.name, api: [] };
                        products.push(p);
                    }
                    p.id = product.id.toString();
                    p.api.push('v1');
                }

                products.sort((a, b) => a.name.localeCompare(b.name));

                this.products.splice(0, this.products.length);
                this.products.push(...products);

                if (this.selectedProduct != null) {
                    let selectedProduct = this.products.find(p => p.name == this.selectedProduct.name);
                    if (selectedProduct) {
                        this.selectedProduct = selectedProduct;
                        let selectedApi = this.selectedProduct.api.find((api: any) => api == this.selectedApi);
                        if (selectedApi) {
                            this.selectedApi = selectedApi;
                        }
                    }
                }
            },
            error: (error: any) => {
                console.log('FirmwareComponent.getProducts.firmwareService.forkJoin.error', error);
                this.progressIndicatorService.progress = false;
                this.alertService.danger('Error');
            }
        });
    }

    selectProduct(name: string) {
        let selectedProduct = this.products.find(p => p.name == name);
        let selectedApi = this.selectedApi;
        if (selectedProduct == undefined) {
            selectedProduct = null;
            selectedApi = null;
        } else {
            if ((selectedApi == null || !selectedProduct.api.includes(selectedApi))) {
                if (selectedProduct.api.length > 0) {
                    selectedApi = selectedProduct.api[0];
                } else {
                    selectedProduct = null;
                    selectedApi = null;
                }
            }
        }
        this.selectedProduct = selectedProduct;
        this.selectedApi = selectedApi;
    }

    selectApi(api: string) {
        this.selectedApi = api;
    }
}
